import type { MaintenanceVariable } from '../../context/MaintenanceProvider';

export const getMaintenance = (
  maintenanceDetail: MaintenanceVariable | undefined,
) => {
  if (!maintenanceDetail) {
    return undefined;
  }
  if (maintenanceDetail.maintenance.showMaintenance === false) {
    return undefined;
  }
  return maintenanceDetail.maintenance;
};
